export const CHUNK_RELOAD_STORAGE_KEY = 'tenant-chunk-reload-at'

const RELOAD_GUARD_WINDOW = 30000
const COPY = {
  en: {
    title: 'Unable to load page',
    detail: 'The page could not be loaded. Refresh to try again.',
    action: 'Refresh'
  },
  zh: {
    title: '\u9875\u9762\u52a0\u8f7d\u5931\u8d25',
    detail: '\u9875\u9762\u6682\u65f6\u65e0\u6cd5\u6b63\u5e38\u52a0\u8f7d\uff0c\u8bf7\u5237\u65b0\u540e\u91cd\u8bd5\u3002',
    action: '\u5237\u65b0'
  },
  es: {
    title: 'No se pudo cargar la pagina',
    detail: 'No se pudo cargar la pagina. Actualiza para intentarlo de nuevo.',
    action: 'Actualizar'
  },
  id: {
    title: 'Halaman gagal dimuat',
    detail: 'Halaman tidak dapat dimuat. Muat ulang untuk mencoba lagi.',
    action: 'Muat ulang'
  },
  vi: {
    title: 'Khong the tai trang',
    detail: 'Khong the tai trang. Hay tai lai de thu lai.',
    action: 'Tai lai'
  }
}

export const isChunkLoadError = error => {
  if (!error) return false
  if (error.name === 'ChunkLoadError') return true
  return /Loading (?:CSS )?chunk .+ failed/i.test(error.message || '')
}

const getCopy = language => {
  const key = String(language || '').toLowerCase().split(/[-_]/)[0]
  return COPY[key] || COPY.en
}

export const showReloadFallback = (options = {}) => {
  const documentRef = options.documentRef || document
  if (!documentRef || !documentRef.body) return false
  if (documentRef.getElementById('tenant-page-load-recovery')) return true

  const language = options.language ||
    (documentRef.documentElement && documentRef.documentElement.lang) ||
    (typeof navigator !== 'undefined' && navigator.language)
  const copy = getCopy(language)
  const container = documentRef.createElement('div')
  const panel = documentRef.createElement('div')
  const title = documentRef.createElement('strong')
  const detail = documentRef.createElement('p')
  const button = documentRef.createElement('button')

  container.id = 'tenant-page-load-recovery'
  container.setAttribute('role', 'alert')
  container.setAttribute('aria-live', 'assertive')
  container.style.cssText = 'position:fixed;inset:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;padding:24px;background:#f5f7fa;color:#1f2937;font-family:Arial,sans-serif;'
  panel.style.cssText = 'width:100%;max-width:420px;padding:28px;background:#fff;border:1px solid #dcdfe6;border-radius:6px;box-shadow:0 8px 24px rgba(0,0,0,.12);text-align:center;'
  title.style.cssText = 'display:block;font-size:20px;line-height:28px;'
  detail.style.cssText = 'margin:12px 0 20px;font-size:14px;line-height:22px;color:#606266;'
  button.type = 'button'
  button.style.cssText = 'min-width:96px;height:38px;padding:0 18px;border:0;border-radius:4px;background:#409eff;color:#fff;font-size:14px;cursor:pointer;'
  title.textContent = copy.title
  detail.textContent = copy.detail
  button.textContent = copy.action
  button.addEventListener('click', () => {
    const reload = options.reload || (() => window.location.reload())
    reload()
  })

  panel.appendChild(title)
  panel.appendChild(detail)
  panel.appendChild(button)
  container.appendChild(panel)
  documentRef.body.appendChild(container)
  return true
}

export const recoverChunkLoad = (error, options = {}) => {
  if (!isChunkLoadError(error)) return false
  const showFallback = options.showFallback || (() => showReloadFallback(options))

  try {
    const storage = options.storage === undefined ? window.sessionStorage : options.storage
    const now = options.now ? options.now() : Date.now()
    const previous = Number(storage.getItem(CHUNK_RELOAD_STORAGE_KEY))
    if (previous && now - previous < RELOAD_GUARD_WINDOW) {
      showFallback()
      return true
    }
    storage.setItem(CHUNK_RELOAD_STORAGE_KEY, String(now))
    const reload = options.reload || (() => window.location.reload())
    reload()
  } catch (_) {
    showFallback()
  }
  return true
}

export const installChunkLoadRecovery = router => {
  router.onError(recoverChunkLoad)
}

export const resetChunkLoadRecovery = storage => {
  try {
    const target = storage === undefined ? window.sessionStorage : storage
    target.removeItem(CHUNK_RELOAD_STORAGE_KEY)
  } catch (_) {
    // Storage can be unavailable in private browsing or restricted contexts.
  }
}
